import { PolicyResponse } from '../../types/policy';

export const getPastEffectiveDatePayload = (
  data: PolicyResponse,
  newDate: string
): PolicyResponse => ({
  ...data,
  messageMetadata: {
    ...data.messageMetadata,
    transactionInformation: {
      ...data.messageMetadata.transactionInformation,
      /** @note during past effective date flow, we must dump the quote number */
      identifier: undefined,
    },
  },
  policy: {
    ...data.policy,
    customerParty: {
      ...data.policy.customerParty,
      /** @note during past effective date flow, we must dump the access token */
      accessToken: undefined,
    },
    policyHeader: {
      ...data.policy.policyHeader,
      policyTransactionInformation: {
        ...data.policy.policyHeader.policyTransactionInformation,
        /** @note during past effective date flow, we must dump the quote number */
        policyNumber: undefined,
        inceptionDate: newDate,
      },
    },
    risks: [
      ...data.policy.risks.map((risk) => ({
        ...risk,
        riskAttachmentDate: newDate,
        riskEffectiveDate: newDate,
      })),
    ],
  },
});
